import { AdaptiveDpr } from "@react-three/drei";
import { useThree } from "@react-three/fiber";
import { useEffect } from "react";
import { Material, Mesh, Object3D } from "three";

export const HandleRendering = () => {
	const { camera, gl, scene } = useThree();

	// const [dpr, setDpr] = useState(1.5);
	useEffect(() => {
		// Wichtig: Auto-Clear deaktivieren, damit die Szene nicht zwischen den Layern gelöscht wird
		gl.autoClear = false;
		// Aktiviere Layer 0 und 1
		camera.layers.enable(0);
		camera.layers.enable(1);
		camera.layers.enable(2);

		return () => {
			// Dispose von Texturen, Materialien und Geometrien
			// Szene durchlaufen und Objekte bereinigen
			scene.traverse((object: Object3D) => {
				if ((object as Mesh).isMesh) {
					const mesh = object as Mesh;

					// Geometrie bereinigen
					if (mesh.geometry) {
						mesh.geometry.dispose();
					}

					// console.log("=> cleanup mesh", mesh, mesh.material);
					// Materialien bereinigen
					if (Array.isArray(mesh.material)) {
						mesh.material.forEach((material) => {
							if (Object.prototype.hasOwnProperty.call((mesh.material as Material).userData, "cleanup")) {
								// console.log("=> cleanup texture");
								material.userData.cleanup();
							}
							material.dispose();
						});
					} else if (mesh.material) {
						if (Object.prototype.hasOwnProperty.call((mesh.material as Material).userData, "cleanup")) {
							// console.log("=> cleanup texture");
							mesh.material.userData.cleanup();
						}

						mesh.material.dispose();
					}
				}
			});

			// Dispose des Renderers
			gl.dispose();
			console.log("Canvas and WebGL resources disposed.");

			//Last resort um zu verhindern dass beim zurück gehen im browser die seite weis bleibt
			document.body.classList.remove("fullscreen");
		};
	}, [camera, gl, scene]);

	return (
		<>
			{/* <PerformanceMonitor onIncline={() => setDpr(2)} onDecline={() => setDpr(1)}></PerformanceMonitor>; */}
			<AdaptiveDpr pixelated />
		</>
	);
};
